<template>
  <div class="main">
    <div style="position:relative;width:100%;" class="banner">
      <img style="width:100%;" src="/static/img/makecloud.png" alt />
      <div @click="register('make')" class="register-btn"></div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    register(kind) {
      this.$store.commit("setKindTab", kind);
      this.$store.commit("clickregistertrue");
    }
  }
};
</script>

<style scope>
.register-btn {
  width: 12%;
  height: 8%;
  background: transparent;
  position: absolute;
  cursor: pointer;
  top: 62%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/components/makecloud/makecloud.vue